import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import "./HelpEdit.css";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";

export const HelpEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";

  const [formData, setFormData] = useState({
    username: "",
    datetime: "",
    status: "",
    description: "",
    reply_message: "",
  });
  const isEditMode = formData.status !== "Viewed";
  const isEditMode2 = data.reply === null;

  console.log("isEditMode", isEditMode);
  console.log("isEditMode2", formData.reply_message);

  useEffect(() => {
    if (data) {
      setFormData({
        username: data?.user_name || "",
        datetime:
          moment(data?.created_at).format("DD-MM-YYYY hh:mm:ss A") || "",
        status: data?.status_label || "",
        description:
          data?.description ||
          "Order cancelled because the home chef ran out of extra servings.",
        reply_message: data?.reply || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleViewed = async () => {
    try {
      if (!data?.id) return;
      console.log("Marked as viewed");
      let res = await post(URLS.HELP_SUPPORT_VIEWED + "/", {
        support_id: data.id,
      });
      if (res?.status === "success") {
        toast.success(res?.message || "Marked as viewed successfully");
        navigate("/help", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to mark as viewed");
      }
    } catch (error) {
      console.error("Error marking as viewed:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  const getStatusColor = () => {
    const statusValue = formData.status || "";
    if (statusValue === "Viewed") return "green";
    if (statusValue === "Created") return "#FF8F00";
    return "red";
  };

  const handleReplyChange = async () => {
    if (!formData.reply_message) {
      toast.info('Reply message is required');
      return;
    }
    if (!data?.id) return;
    const res = await post(`${URLS.HELP_SUPPORT_REPLY}${data?.id}/`, { reply: formData.reply_message });
    console.log("res reply", res);
    if (res?.status === "success") {
      toast.success(res?.message || "Reply sent successfully");
      navigate("/help", { state: { page: page || 1 } });
    } else {
      toast.error(res?.message || "Failed to mark as viewed");
    }
  }

  return (
    <>
      <PageHeader
        title="Help & Support"
        showBackButton={true}
        onBackClick={() => navigate("/help", { state: { page: page || 1 } })}
      />
      <div className="help-edit-container">
        <div className="help-edit-form">
          <div className="form-row">
            <div className="form-group">
              <label>User Name</label>
              <input
                type="text"
                name="username"
                value={formData.username || ""}
                onChange={handleChange}
                disabled={!isEditMode}
                readOnly={!isEditMode}
              />
            </div>
            <div className="form-group">
              <label>Date & Time</label>
              <input
                type="text"
                name="datetime"
                value={formData.datetime || ""}
                onChange={handleChange}
                disabled={!isEditMode}
                readOnly={!isEditMode}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Status</label>
              <input
                type="text"
                name="status"
                value={formData.status || ""}
                onChange={handleChange}
                disabled={!isEditMode}
                readOnly={!isEditMode}
                style={{ color: getStatusColor(), fontWeight: 500 }}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description || ""}
                onChange={handleChange}
                disabled={!isEditMode}
                readOnly={!isEditMode}
                rows={4}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Reply Message</label>
              <textarea
                type="text"
                name="reply_message"
                value={formData.reply_message || ""}
                onChange={handleChange}
                disabled={!isEditMode2}
                readOnly={!isEditMode2}
                rows={4}
              />
            </div>

          </div>
          {isEditMode2 && (
            <button
              type="button"
              className="btn-viewed"
              onClick={handleReplyChange}
            >
              Reply
            </button>
          )}
          {formData.status !== "Viewed" && (
            <div className="form-actions">
              <button
                type="button"
                className="btn-viewed"
                onClick={handleViewed}
              >
                Viewed
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
